import { ButtonIcon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	buttonIcon,
	buttonIconIcon,
	tableTh,
} from '@mage-ui/styled-system/recipes';

//TableHeading
export const TableTh = ({
	data,
	reversed,
	sorted,
	onSort,
	className,
	showSortButton = true,
	...props
}) => {
	return (
		<th
			className={cx(tableTh().root, className)}
			{...props}
			colSpan={data?.colspan}
			rowSpan={data?.rowspan}
		>
			<span className={tableTh().content}>
				{data?.title ?? ' '}

				{showSortButton && data?.title?.replace(' ', '') && (
					<ButtonIcon
						icon={
							sorted
								? reversed
									? 'arrow_drop_up'
									: 'arrow_drop_down'
								: 'unfold_more'
						}
						label={data?.title}
						classNames={{
							root: cx(
								buttonIcon({
									variant: 'unstyled',
									size: 's',
									shape: 'rounded',
								}),
								tableTh().cta,
							),
							icon: buttonIconIcon({ size: 's' }),
						}}
						onClick={onSort}
					/>
				)}
			</span>
		</th>
	);
};
